import { render, staticRenderFns } from "./smartO_task.vue?vue&type=template&id=f156633c&scoped=true"
import script from "./smartO_task.vue?vue&type=script&lang=js"
export * from "./smartO_task.vue?vue&type=script&lang=js"
import style0 from "./smartO_task.vue?vue&type=style&index=0&id=f156633c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f156633c",
  null
  
)

export default component.exports